import React, { useEffect, useState } from "react";

import Paper from "@mui/material/Paper";
import { prop } from "ramda";

import IALineChartLocf from "root/components/Charts/IALineChartLocf";
import PagesTab from "root/components/global/pages-tabs";

import useNavigationMemory from "root/hooks/useNavigationMemory";

import { getAxisDate } from "root/js/utils";

const PromotionMediaDiagramDynamic = ({ advertDynamics }) => {
  const [isCheckOne, setIsCheckOne] = useState(true);
  const [isCheckTwo, setIsCheckTwo] = useState(true);
  const [isCheckThree, setIsCheckThree] = useState(true);
  const [isCheckFour, setIsCheckFour] = useState(true);

  const [diagramTab, setDiagramTab] = useState(0);

  const { changeParams } = useNavigationMemory();

  const onChangeTab = tab => {
    setDiagramTab(tab);
  };

  useEffect(() => {
    changeParams("diagramTab", diagramTab);
  }, [diagramTab]);

  const formattedData = (elem, field1, field2) => ({
    date: getAxisDate(elem.currentDate),
    dateTick: getAxisDate(elem.currentDate),
    checkOnePress: prop(field1, prop("current", elem)),
    checkTwoPress: prop(field1, prop("prev", elem)),
    checkThreePress: prop(field2, prop("current", elem)),
    checkFourPress: prop(field2, prop("prev", elem)),
  });

  const diagrams = [
    {
      keyIndex: 0,
      title: "CPM",
      component: () => {
        const cpmData = advertDynamics?.map(elem => formattedData(elem, "sum", "cpm"));
        return generateComponentDiagram(cpmData, "руб", "руб", "руб", "руб");
      },
    },
    {
      keyIndex: 1,
      title: "CTR",
      component: () => {
        const ctrData = advertDynamics?.map(elem => formattedData(elem, "sum", "ctr"));
        return generateComponentDiagram(ctrData, "руб", "руб", "%", "%");
      },
    },
    {
      keyIndex: 2,
      title: "CPC",
      component: () => {
        const cpcData = advertDynamics?.map(elem => formattedData(elem, "sum", "cpc"));
        return generateComponentDiagram(cpcData, "руб", "руб", "руб", "руб");
      },
    },
    {
      keyIndex: 3,
      title: "CR",
      component: () => {
        const crData = advertDynamics?.map(elem => formattedData(elem, "sum", "cr"));
        return generateComponentDiagram(crData, "руб", "руб", "%", "%");
      },
    },
  ];

  const labelsMap = {
    0: ["CPM в текущем периоде", "CPM в предыдущем периоде"],
    1: ["CTR в текущем периоде", "CTR в предыдущем периоде"],
    2: ["CPC в текущем периоде", "CPC в предыдущем периоде"],
    3: ["CR в текущем периоде", "CR в предыдущем периоде"],
  };

  const labels = labelsMap[diagramTab] || ["CR в текущем периоде", "CR в предыдущем периоде"];
  const generateComponentDiagram = (
    data,
    currencyName,
    currencyNameTwo,
    currencyNameThree,
    currencyNameFour
  ) => {
    return (
      <IALineChartLocf
        data={data}
        currencyName={currencyName}
        currencyNameTwo={currencyNameTwo}
        currencyNameThree={currencyNameThree}
        currencyNameFour={currencyNameFour}
        isCheckOne={isCheckOne}
        isCheckTwo={isCheckTwo}
        isCheckThree={isCheckThree}
        isCheckFour={isCheckFour}
        setIsCheckOne={setIsCheckOne}
        setIsCheckTwo={setIsCheckTwo}
        setIsCheckThree={setIsCheckThree}
        setIsCheckFour={setIsCheckFour}
        labelOne={"Затраты в текущем периоде"}
        labelTwo={"Затраты в предыдущем периоде"}
        labelThree={labels[0]}
        labelFour={labels[1]}
        checkOne={true}
        checkTwo={true}
        checkThree={true}
        checkFour={true}
        colorOne={"#33caa6"}
        colorTwo={"#7d3ece"}
        colorThree={"#08adeb"}
        colorFour={"#ff7f00"}
        isBarOne={true}
        isBarTwo={true}
        isShowYAxisTwoRight={true}
        isShowYAxisTwoLeft={true}
      />
    );
  };

  return (
    <Paper
      elevation={0}
      style={{
        width: "100%",
        borderRadius: "10px",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
      }}>
      <PagesTab tab={diagramTab} pages={diagrams} onChange={onChangeTab} />
    </Paper>
  );
};

export default PromotionMediaDiagramDynamic;
